import { Row, Col } from 'reactstrap'
import styles from './Footer.module.scss'
import style from'./Footer.module.scss';
import { useContext } from 'react';
import { AppContext } from '../../globalContext/context';

export default function Footer() {

  const { footer, setting } = useContext(AppContext);

  if(footer) {
    footer.sort((a,b) => a.order_view - b.order_view);
  }

  return (
    <div className={`${styles.lgtFooter} p-4 mt-4` }>
      <div className='container-xxl'>
        <Row>
          <Col sm={4}>
            {
              setting
                ? <img src={`${`${process.env.REACT_APP_API_URL}${setting.logo_light
                }`}`} alt="Letgo or trade" width={'120px'} />
                : ''

            }
            <p className={`${style.FooterText}`}>
              With letgo or trade we want to create a sustainable future where nothing is thrown away
              unused or sold at high listing rates with ridiculous success fees.
            </p>
            <ul className={`list-unstyled d-flex ${styles.social} `}>
              <li className={`me-2`}>
                <a href='https://t.me/letgo_or_trade' target='_blank' className={`${style.FooterText} ${style.link}`}>
                  <i className='bi bi-telegram'></i>
                </a>
              </li>
              <li className={`me-2`}>
                <a href='https://instagram.com/letgo_or_trade' target='_blank' className={`${style.FooterText} ${style.link}`}>
                  <i className='bi bi-instagram'></i>
                </a>
              </li>
              {/* <li className={`me-2`}>
                <a href='#' className={`${style.FooterText} ${style.link}`}>
                  <i className='bi bi-facebook'></i>
                </a>
              </li>  */}
              {/* <li>
                <a href='#' className={`${style.FooterText} ${style.link}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-twitter-x" viewBox="0 0 16 16">
                    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                  </svg>
                </a>
              </li> */}
            </ul>    
          </Col>
          <Col sm={3}>
              {
                setting &&
                  <>
                    <h5>Contact</h5>
                    <ul className={`list-unstyled`}>
                      <li>
                        {
                          setting.email &&
                            <div>
                              <i className={`bi bi-envelope-at me-1 ${styles.FooterText}`}></i>
                              <span className={`me-2 fw-bold ${styles.FooterText}`}>
                                Email:
                              </span>
                              <a href={`mailto:${setting.email}`} className={`text-decoration-none ${styles.FooterText}`} >
                                {setting.email}
                              </a>
                            </div>
                        }
                      </li>
                      <li>
                        {
                          setting.phone &&
                            <div>
                              <i className={`bi bi-telephone me-1 ${styles.FooterText}`}></i>
                              <span className={`me-2 fw-bold ${styles.FooterText}`}>
                                Phone:
                              </span>
                              <a className={`text-decoration-none ${styles.FooterText}`} href={`tel:${setting.phone}`}>
                                {setting.phone}
                              </a>                                              
                            </div>
                      }
                      </li>
                    </ul>
                  </>
              }
          </Col>
          <Col sm={3}>
              {
                footer &&
                  <>
                    <h5>Useful Menu</h5>
                    <ul className={`list-unstyled`}>
                      {
                        footer.map((item) => (
                          <li 
                            key={item.id}
                          >
                            <a 
                              href={item.link}
                              target={item.is_blank ? '_blank' : '_self'}
                              className={`text-decoration-none ${style.FooterText} ${style.link}`}
                              >
                              {item.title}
                            </a>
                          </li>
                        ))
                      }
                    </ul>
                  </>
              }
          </Col>
        </Row>
      </div>
    </div>
  )
}
